<template>
	<div style="padding: 20px;">
		<el-form label-position="right" label-width="145px" :model="formdata">
			<div class="thead">亲子家庭活动分享统计表</div>
			<el-row :gutter="20">
				<el-col :span="8">
					<el-form-item label="分享奖励设定">
						<el-input  disabled v-model="formdata.set" size="small"></el-input  disabled>
						<el-input  disabled v-model="formdata.f_id" style="display: none;"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="活动分享关键词">
						<el-input  disabled v-model="formdata.key_word" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="8">
					<el-form-item label="平均集赞数量">
						<el-input  disabled v-model="formdata.agv_laud" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="分享的亲子家庭数量">
						<el-input  disabled v-model="formdata.share" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<div class="upload">
<!-- 					<div class="add-img" >

						<ul class="img-list">
							<li v-for="(url,index) in imgList">
								<img class="del" src="/static/qmsj/img/delpng.png" @click.stop="delImg(index)" />
								<img class="yulantu" :src="url.file.src">
							</li>
						</ul>
					</div> -->


				</div>
			</el-row>
			<div class="thead">活动数据反馈表</div>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="活动名称">
						<el-input  disabled v-model="formdata.title" size="small" ></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动日期">
						<el-input  disabled v-model="formdata.start_time" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动地点">
						<el-input  disabled v-model="formdata.site" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动场数">
						<el-input  disabled v-model="formdata.farm_num" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="非会员人数">
						<el-input  disabled v-model="formdata.no_vip" size="small" style="width:85%"></el-input  disabled>
						<span>{{formdata.on_vip2}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="报名人数">
						<el-input  disabled v-model="formdata.enroll" size="small" style="width:85%"></el-input  disabled>
						<span>{{formdata.enroll2}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="参与人数">
						<el-input  disabled v-model="formdata.join" size="small" style="width:85%"></el-input  disabled>
						<span>{{formdata.join2}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="会员人数">
						<el-input  disabled v-model="formdata.vip" size="small" style="width:85%"></el-input  disabled>
						<span>{{formdata.vip2}}</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="新增会员人数">
						<el-input  disabled v-model="formdata.add_vip" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动预算">
						<el-input  disabled v-model="formdata.budget" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="实际费用">
						<el-input  disabled v-model="formdata.actual" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="转化率">
						<el-input  disabled v-model="formdata.lv" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="活动宣传渠道">
						<el-input  disabled type="textarea" v-model="formdata.propagate" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="活动渠道">
						<el-input  disabled type="textarea" v-model="formdata.channels" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="家长反馈意见">
						<el-input  disabled type="textarea" v-model="formdata.feedback" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="活动效果">
						<el-input  disabled type="textarea" v-model="formdata.effect" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="活动总结">
						<el-input  disabled type="textarea" v-model="formdata.summary" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="其他">
						<el-input  disabled type="textarea" v-model="formdata.other" size="small"></el-input  disabled>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="but">
			<button @click="fanhui()">返回</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				fid: '',
				formdata: {
					f_id: '',
					set: '', // 分享奖励设定
					key_word: '', // 活动分享关键词
					agv_laud: '', // 平均集赞数量
					share: '', // 参与分享的亲子家庭数量
					title: '', //活动名称
					start_time: '', //活动日期
					site: '', // 活动地点
					farm_num: '', // 活动场次
					no_vip: '', // 非会员人数
					enroll: '', // 报名人数
					join: '', // 参与人数
					vip: '', // 会员人数
					add_vip: '', // 新增会员人数
					budget: '', // 活动预算
					actual: '', // 实际费用
					lv: '', // 转化率
					propagate: '', // 活动宣传渠道
					channels: '', // 活动渠道
					feedback: '', // 家长反馈意见
					effect: '', // 活动效果
					summary: '', // 活动总结
					other: '', // 其他
				},
				imgList: [],
			};
		},
		mounted: function() {
			var self = this
			self.token = self.$cookies.get("token")
			self.fid = self.$route.query.id
			self.formdata.f_id = self.fid
			$.ajax({
				url: process.env.apiUrl + "saas/plan/already",
				type: "post",
				async: false,
				data: {
					token: self.token,
					f_id: self.fid
				},
				success: function(data) {
					console.log(data)
					self.formdata = data.data
				}
			})
		},
		methods: {
			// 跳转
			fanhui: function() {
				this.$router.push('zbhd')
			},
		},
		filters: {

		},
		watch: { //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果

		},
	}
</script>

<style scoped>
	.thead {
		border-left: 4px solid #8CBB77;
		margin-top: 15px;
		margin-bottom: 10px;
		height: 25px;
		line-height: 25px;
		font-size: 18px;
		padding-left: 12px;
	}

	.el-form-item__label {
		font-size: 12px;
	}

	.form1 {
		padding-bottom: 20px;
	}

	.upload {
		padding: 0px 30px;
	}

	.but {
		padding: 10px;
		text-align: center;
	}

	button {
		width: 211px;
		height: 50px;
		border-radius: 25px;
		background: #8CBB77;
		line-height: 50px;
		color: white;
		font-size: 16px;
		cursor: pointer;
		border: 0;
		outline: none;
	}

	.add-img {
		width: 100%;
		padding: 10px;
	}

	.add-img p {
		color: #999;
	}

	.add {
		display: inline-block;
		margin-bottom: 20px;
	}

	.add-image {
		/*padding-top: 15px;*/
		margin-left: 10px;
		text-align: center;
		line-height: 100px;
		font-size: 50px;
		width: 100px;
		top: 20px;
		height: 100px;
		border: 1px dashed rgba(0, 0, 0, .2);
	}

	.add-image .icon-camera {
		font-size: 24px;
	}

	.good-item .choose {
		color: #fff;
		background-color: #87582E;
		border: 0;
	}

	.mui-btn-block {
		border: 0;
		border-radius: 0;
		background-color: #87582E;
		color: #fff;
		margin-bottom: 0;
		bottom: 0;
	}

	.mui-buttom {
		position: fixed;
		width: 100%;
		bottom: 0;
		z-index: 999;

	}

	/*九宫格*/
	.img-list {
		overflow: hidden;
	}

	.img-list>li {
		float: left;
		width: 100px;
		height: 100px;
		text-align: center;
		position: relative;
		margin-right: 5px;
	}

	.img-list>li>div {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.img-list>li>div .app-bg {
		width: 100%;
		height: 100%;
	}

	.mui-fullscreen {
		z-index: 9999;
	}

	.del {
		position: absolute;
		width: 18px;
		top: 0;
		right: 0;
		z-index: 999
	}

	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.yulantu {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/huodong/fangcha.vue